
import OrderProductImage from '@marketplace/components/account/orders/parts/order-product-image.vue'
import Checkbox from '@marketplace/components/forms/inputs/checkbox.vue'
export default {
    name: 'OrderReorderRow',

    components: {
        Checkbox,
        OrderProductImage,
    },

    props: {
        node: {
            type: Object,
            default: () => {},
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        disabledMessage: {
            type: String,
            default: 'account.orderpage.modal.reorder.listing_not_active',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        displayedProductTitle() {
            if (this.node.ticaArticleTitle) {
                return this.node.ticaArticleTitle
            }

            return this.node.title || ''
        },
        displayedProductImage() {
            return (
                this.node.images?.edges?.[0]?.node?.transformedUrl ||
                this.node.listing?.images?.edges?.[0]?.node?.transformedUrl
            )
        },
    },
}
